import { Button, Col, Form, Row, Select } from 'antd'
import ManagementList from '../../../components/Corporate/Report/ManagementList'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import { rules, threeFormItemLayout } from '../../../modules/FormItems'
import React from 'react'

import { compose } from 'recompose'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'

const { Option } = Select

Management.propTypes = {}

const YearSelect = compose(
  withData({
    data: [
      { value: '2021', key: '2021' },
      { value: '2020', key: '2020' },
      { value: '2019', key: '2019' },
      { value: '2018', key: '2018' },
      { value: '2017', key: '2017' },
      { value: '2016', key: '2016' },
    ],
  }),
  withSort
)(CustomSelect)

function Management(props) {
  const { submitting, submit } = props
  const { getFieldDecorator } = props.form
  const [CompaniesSelect] = useFetchSelectUrl({
    name: `corporates`,
    url: `corporates/`,
    /*payload: [
      {
        _id:
          'members/294426198169,' + // MONDIALE AUSTRALIA PTY LTD
          'members/294426329241,' + // MONDIALE ENGINEERING SDN BHD
          'members/294457000089,' + // MONDIALE GROUP PTE LTD
          'members/10333923050595,' + // MONDIALE GROUP SERVICES KENYA LIMITED
          'members/3473770102937,' + // MONDIALE ME & A DMCC
          'members/294426591385,' + // MONDIALE NIUGINI PTE LTD
          'members/4834795471001,' + // MONDIALE NIUGINI PTE LTD (PNG BRANCH)
          'members/294426722457,' + // MONDIALE STEEL PRODUCTS (CHENGDU) LTD
          'members/294426853529,' + // MONDIALE TECHNICAL SERVICES PTE LTD
          'members/294426984601,' + // MONDIALE TRADING FZE
          'members/294427246745,' + // MONDIALE USA INC
          'members/294428950681', // MUNDO GROUP SERVICES MOCAMBIQUE SA
        fn: '-- ALL MONDIALE GROUP COMPANIES --',
      },
      {
        _id:
          'members/294426460313,' + // MMEA PTE LTD
          'members/294427115673,' + // MMEA (UK) LTD
          'members/10333996845050', // SOUTER TRADING INTERNATIONAL LTD
        fn: '-- ALL MMEA/SOUTER GROUP COMPANIES --',
      },
    ],*/
  })

  return (
    <Form>
      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label={'Year'}>
            {getFieldDecorator('year', {
              initialValue: '2021',
              rules: rules.select,
            })(<YearSelect />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...threeFormItemLayout} label={'Company'}>
            {getFieldDecorator('companyList')(<CompaniesSelect keyAtr={'_id'} valueAtr={'fn'} mode="multiple" />)}
          </Form.Item>
        </Col>
      </Row>
      <Button style={{ width: '100px' }} type="primary" loading={submitting} onClick={submit}>
        Submit
      </Button>
      <ManagementList {...props} />
    </Form>
  )
}

export default Form.create()(Management)
